var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.alterLoginLoading,
          expression: "alterLoginLoading",
          modifiers: { body: true }
        }
      ],
      attrs: { id: "login-container" }
    },
    [
      _c("div", { staticClass: "title" }, [
        _c("span", { staticStyle: { "font-size": "36px", color: "#f8fafc" } }, [
          _vm._v(_vm._s(_vm.title))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "login-div" },
        [
          _c(
            "el-row",
            { staticClass: "row-container" },
            [
              _c("el-col", { staticClass: "left-col", attrs: { span: 12 } }, [
                _c("div", { staticStyle: { width: "100%", height: "100%" } }, [
                  _c("img", {
                    staticStyle: { height: "auto", "max-height": "100%" },
                    attrs: { src: require("@/assets/logo-left.png"), alt: "" }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-col",
                { staticClass: "right-row-container", attrs: { span: 12 } },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "330px", "marin-top": "30px" } },
                    [
                      _c(
                        "div",
                        { staticStyle: { color: "#42464f" } },
                        _vm._l(_vm.loginTypes, function(type) {
                          return _c(
                            "span",
                            {
                              key: type.value,
                              class:
                                _vm.loginType === type.value
                                  ? "login-type active"
                                  : "login-type",
                              on: {
                                click: function($event) {
                                  return _vm.changeLoginType(type.value)
                                }
                              }
                            },
                            [_vm._v(_vm._s(type.name))]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading"
                            }
                          ],
                          ref: "loginForm",
                          staticClass: "login-form",
                          attrs: {
                            model: _vm.loginForm,
                            rules: _vm.rules,
                            "label-position": "left",
                            "label-width": "0px"
                          }
                        },
                        [
                          _vm.loginType === "1"
                            ? _c(
                                "el-form-item",
                                {
                                  staticStyle: { "text-align": "left" },
                                  attrs: { prop: "username" }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "common-label",
                                      attrs: { for: "username" }
                                    },
                                    [_vm._v("手机号")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    attrs: {
                                      id: "username",
                                      type: "text",
                                      "auto-complete": "off",
                                      placeholder: "请输入手机号"
                                    },
                                    model: {
                                      value: _vm.loginForm.username,
                                      callback: function($$v) {
                                        _vm.$set(_vm.loginForm, "username", $$v)
                                      },
                                      expression: "loginForm.username"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.loginType === "2"
                            ? _c(
                                "el-form-item",
                                {
                                  staticStyle: { "text-align": "left" },
                                  attrs: { prop: "idCard" }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "common-label",
                                      attrs: { for: "username" }
                                    },
                                    [_vm._v("身份证号")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    attrs: {
                                      id: "username",
                                      type: "text",
                                      "auto-complete": "off",
                                      placeholder: "请输入身份证号"
                                    },
                                    model: {
                                      value: _vm.loginForm.idCard,
                                      callback: function($$v) {
                                        _vm.$set(_vm.loginForm, "idCard", $$v)
                                      },
                                      expression: "loginForm.idCard"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.loginType === "3"
                            ? _c(
                                "el-form-item",
                                {
                                  staticStyle: { "text-align": "left" },
                                  attrs: { prop: "username" }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "common-label",
                                      attrs: { for: "username" }
                                    },
                                    [_vm._v("用户名 / 手机号")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    attrs: {
                                      id: "username",
                                      type: "text",
                                      "auto-complete": "off",
                                      placeholder: "请输入用户名或手机号"
                                    },
                                    model: {
                                      value: _vm.loginForm.username,
                                      callback: function($$v) {
                                        _vm.$set(_vm.loginForm, "username", $$v)
                                      },
                                      expression: "loginForm.username"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "text-align": "left" },
                              attrs: { prop: "password" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "common-label",
                                  attrs: { for: "password" }
                                },
                                [_vm._v("密码")]
                              ),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: {
                                  id: "password",
                                  type: "password",
                                  "auto-complete": "off",
                                  placeholder: "请输入密码"
                                },
                                model: {
                                  value: _vm.loginForm.password,
                                  callback: function($$v) {
                                    _vm.$set(_vm.loginForm, "password", $$v)
                                  },
                                  expression: "loginForm.password"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "capcha-form-item",
                              attrs: { prop: "capcha" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "capcha-label",
                                  attrs: { for: "capcha" }
                                },
                                [_vm._v("验证码")]
                              ),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: {
                                  type: "text",
                                  id: "capcha",
                                  placeholder: "请输入验证码",
                                  "auto-complete": "off"
                                },
                                model: {
                                  value: _vm.loginForm.capcha,
                                  callback: function($$v) {
                                    _vm.$set(_vm.loginForm, "capcha", $$v)
                                  },
                                  expression: "loginForm.capcha"
                                }
                              }),
                              _vm._v(" "),
                              _c("vue-img-verify", {
                                ref: "vueImgVerify",
                                on: { getImgCode: _vm.getImgCode }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errorMsg,
                                  expression: "errorMsg"
                                }
                              ],
                              staticStyle: {
                                color: "#ed4014",
                                "font-size": "12px",
                                "text-align": "right",
                                margin: "0 auto -20px"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.errorMsg) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "login-btn-form-item",
                              staticStyle: {
                                width: "100%",
                                "margin-top": "40px"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "login-button",
                                  staticStyle: { width: "100%" },
                                  attrs: { type: "primary" },
                                  on: { click: _vm.submitClick }
                                },
                                [_vm._v("登录")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "100%" },
                              style: _vm.visibility,
                              attrs: { type: "text" },
                              on: { click: _vm.forgetPwd }
                            },
                            [_vm._v("忘记密码？")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.loginType === "1"
                        ? _c("p", { staticClass: "tips" }, [
                            _c(
                              "span",
                              { staticStyle: { visibility: "hidden" } },
                              [_vm._v("各行政机构管理员")]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.loginType === "2"
                        ? _c(
                            "p",
                            { staticClass: "tips", style: _vm.visibility },
                            [
                              _vm._v("\n            温馨提示：\n            "),
                              _c("br"),
                              _vm._v("无\n            "),
                              _c("span", [
                                _vm._v(
                                  "各行政机构管理员、行政机构用户、学校管理员使用该入口登录"
                                )
                              ]),
                              _vm._v(" "),
                              _c("br")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.loginType === "3"
                        ? _c("p", { staticClass: "tips" }, [
                            _vm._v("\n            温馨提示：\n            "),
                            _c("br"),
                            _vm._v(
                              "各行政机构管理员、行政机构用户、学校管理员使用该入口登录\n          "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "footer-row" },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c("p", [_vm._v("© 2020 " + _vm._s(_vm.copyright))]),
            _vm._v(" "),
            _c("p", [_vm._v("技术支持：北京捷成世纪科技股份有限公司")])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("change-pass-editor", {
        attrs: { visible: _vm.editorVisible, schoolName: _vm.schoolName },
        on: {
          "update:visible": function($event) {
            _vm.editorVisible = $event
          },
          "change-succ": _vm.resetForm
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-ef68022e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-ef68022e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = null
// module chunks = 